import {
  DataAdministrationSidebarAppFeaturesId,
  EvidencePlatformSidebarAppID,
  ProjectsSidebarAppFeatureId,
  OrganizationsSidebarAppFeatureId,
  UserRolesIdsEnum,
} from '@verantos-dev/core-enums';
import { SidebarApp, SidebarAppFeature } from '@verantos-dev/types-common';

/**
 * Sidebar App Features
 */
export const DataIntakeFeature: SidebarAppFeature = {
  featureId: DataAdministrationSidebarAppFeaturesId.dataIntake,
  featureName: 'Data Intake', // default is overriden by intl in hook
  priority: 1,
};

export const CohortsFeature: SidebarAppFeature = {
  featureId: ProjectsSidebarAppFeatureId.cohorts,
  featureName: 'Cohorts', // default is overriden by intl in hook
  priority: 1,
};

export const DataReliabilityFeature: SidebarAppFeature = {
  featureId: ProjectsSidebarAppFeatureId.dataReliability,
  featureName: 'Data Reliability', // default is overriden by intl in hook
  priority: 2,
};

export const DatasetDeliveryFeature: SidebarAppFeature = {
  featureId: DataAdministrationSidebarAppFeaturesId.datasetDelivery,
  featureName: 'Dataset Delivery', // default is overridden by intl in hook
  priority: 2,
};

export const OrganizationsItem: SidebarAppFeature = {
  featureId: OrganizationsSidebarAppFeatureId.organizations,
  featureName: 'Organizations', // default is overridden by intl in hook
  priority: 1,
};

/**
 * Sidebar Apps
 */
export const PROJECTS_SIDEBAR_APP: SidebarApp = {
  sectionTitleId: 'projects',
  appId: EvidencePlatformSidebarAppID.projects,
  appName: EvidencePlatformSidebarAppID.projects,
  priority: 1,
  features: [CohortsFeature, DataReliabilityFeature],
  additionalItems: [],
};

export const CONCEPT_GROUPS_SIDEBAR_APP: SidebarApp = {
  appId: EvidencePlatformSidebarAppID.conceptGroups,
  appName: EvidencePlatformSidebarAppID.conceptGroups,
  priority: 2,
  features: [],
  additionalItems: [],
};

export const DATA_ADMINISTRATION_SIDEBAR_APP: SidebarApp = {
  sectionTitleId: 'dataAdmin',
  appId: EvidencePlatformSidebarAppID.dataAdministration,
  appName: EvidencePlatformSidebarAppID.dataAdministration,
  priority: 3,
  features: [],
  additionalItems: [],
};

export const ORGANIZATIONS_SIDEBAR_APP: SidebarApp = {
  appId: EvidencePlatformSidebarAppID.organizations,
  appName: EvidencePlatformSidebarAppID.organizations,
  priority: 5,
  features: [],
  additionalItems: [],
};

export const USERS_SIDEBAR_APP: SidebarApp = {
  sectionTitleId: 'sysAdmin',
  appId: EvidencePlatformSidebarAppID.users,
  appName: EvidencePlatformSidebarAppID.users,
  priority: 4,
  features: [],
  additionalItems: [OrganizationsItem],
};

export const EXTRACTION_ACCURACY_APP: SidebarApp = {
  sectionTitleId: 'extractionAccuracy',
  appId: EvidencePlatformSidebarAppID.extractionAccuracy,
  appName: EvidencePlatformSidebarAppID.extractionAccuracy,
  priority: 6,
  features: [],
  additionalItems: [],
};

export const SIDEBAR_APPS: SidebarApp[] = [
  PROJECTS_SIDEBAR_APP,
  CONCEPT_GROUPS_SIDEBAR_APP,
  DATA_ADMINISTRATION_SIDEBAR_APP,
  USERS_SIDEBAR_APP,
  EXTRACTION_ACCURACY_APP,
  // ORGANIZATIONS_SIDEBAR_APP,
];

export const getVerantosApplicationDisplayNameForId = (appId: EvidencePlatformSidebarAppID) => {
  switch (appId) {
    case EvidencePlatformSidebarAppID.dataAdministration:
      return 'Data Administration';
    case EvidencePlatformSidebarAppID.projects:
      return 'Projects';
    case EvidencePlatformSidebarAppID.organizations:
      return 'Organizations';
    case EvidencePlatformSidebarAppID.users:
      return 'Users';
    case EvidencePlatformSidebarAppID.conceptGroups:
      return 'Concept groups';
    default:
      return '';
  }
};

export const appIdToClaimCheckDefinitionMap: {
  [appId: string]: UserRolesIdsEnum;
} = {
  [EvidencePlatformSidebarAppID.projects]: UserRolesIdsEnum.OR_RESEARCHER,
  [EvidencePlatformSidebarAppID.dataAdministration]: UserRolesIdsEnum.VRN_DATA_ADMIN,
  [EvidencePlatformSidebarAppID.organizations]: UserRolesIdsEnum.SA_ADMIN,
  [EvidencePlatformSidebarAppID.users]: UserRolesIdsEnum.SA_ADMIN,
  [EvidencePlatformSidebarAppID.extractionAccuracy]: UserRolesIdsEnum.VRN_DATA_ADMIN,
  [EvidencePlatformSidebarAppID.conceptGroups]: UserRolesIdsEnum.OR_RESEARCHER,
};
